<template>
    <Icon name="italic">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>text-italic</title>
            <path
                d="M22.5.248H14.863a1.25,1.25,0,0,0,0,2.5h1.086a.25.25,0,0,1,.211.384L4.78,21.017a.5.5,0,0,1-.422.231H1.5a1.25,1.25,0,0,0,0,2.5H9.137a1.25,1.25,0,0,0,0-2.5H8.051a.25.25,0,0,1-.211-.384L19.22,2.98a.5.5,0,0,1,.422-.232H22.5a1.25,1.25,0,0,0,0-2.5Z"
            />
        </svg>
    </Icon>
</template>

<script>
import Icon from './icon';
export default {
    components: {
        Icon,
    },
};
</script>
